<button
  [ngClass]="['action-btn', 'action-btn--' + size, 'action-btn--' + variant]"
  [disabled]="disabled"
  (click)="handleClick()">

  <umkt-icon *ngIf="icon && icon.position !== 'right'" [icon]="icon"></umkt-icon>
    <span>{{ label }}</span>
  <umkt-icon *ngIf="icon && icon.position === 'right'" [icon]="icon"></umkt-icon>

</button>